<!--
    File: CouponType.vue
-->

<template>
    <v-container fluid>
        <v-row>
            <v-col sm="12" md="6">
                <v-card outlined>
                    <v-toolbar class="elevation-0" color="background">
                        <v-toolbar-title>쿠폰 관리</v-toolbar-title>
                    </v-toolbar>
                    <v-list class="pa-3">
                        <v-subheader>COUPONS : {{couponList.length}}</v-subheader>
                        <v-list-item-group color="primary">
                        <v-list-item v-for="couponType in couponList" :key="couponType.id" @click="select(couponType)">
                            <v-list-item-icon><v-icon class="mr-3">mdi-ticket</v-icon></v-list-item-icon>
                            <v-list-item-title v-text="couponType.name" />
                            <v-list-item-subtitle v-text="couponType.memo" />
                            <v-list-item-subtitle v-text="couponType.time + ' 분'" />
                        </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card>
                <v-row class="pa-3" align="center">
                    <v-col cols="12" class="text-right pr-0">
                        <v-btn v-if="edit == null" color="primary" elevation="0" @click="add()">신규 쿠폰 추가</v-btn>
                    </v-col>
                </v-row>
            </v-col>
            <v-col sm="12" md="6">
                <v-card outlined v-if="couponType || edit">
                    <v-toolbar class="mb-3 elevation-0" color="background">
                        <v-toolbar-title>{{subtitle}}</v-toolbar-title>
                    </v-toolbar>
                    <v-row class="pt-3 pl-3 pr-3" v-for="(content, i) in contents" :key="i" align-top>
                        <v-col cols="1"><v-icon>{{content.icon}}</v-icon></v-col>
                        <v-col cols="3">{{content.title}}</v-col>
                        <v-col cols="8" v-if="edit == null || i > 2">{{content.text}}</v-col>

                        <v-col cols="8" v-if="edit && i == 0" class="pt-0 pb-0">
                            <v-text-field class="pt-1 pb-0" v-model="edit.name" id="name" />
                        </v-col>

                        <v-col cols="8" v-if="edit && i == 1" class="pt-0 pb-0">
                            <v-text-field class="pt-1 pb-0" v-model="edit.time" type="number" />
                        </v-col>

                        <v-col cols="8" v-if="edit && i == 2" class="pt-0 pb-0">
                            <v-text-field class="pt-1 pb-0" v-model="edit.memo" />
                        </v-col>

                    </v-row>
                    <v-spacer class="pa-3"/>
                    <v-divider />
                    <v-row class="pa-3" align="center" justify="end">
                        <v-col class="text-left" v-if="edit == null">
                            <v-btn color="accent" elevation="0" @click="remove()">삭제</v-btn>
                        </v-col>
                        <v-col class="text-right" v-if="edit == null">
                            <v-btn color="primary" elevation="0" @click="modify()">수정</v-btn>
                        </v-col>
                        <v-col class="text-right" v-if="edit">
                            <v-btn color="normal" @click="cancel()" class="mr-3 elevation-0">취소</v-btn>
                            <v-btn v-if="edit && couponType == null" color="secondary" elevation="0" @click="insert()">등록</v-btn>
                            <v-btn v-if="edit && couponType" color="secondary" elevation="0" @click="update()">적용</v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import axios from 'axios'
import util from '../utils/util'

export default {
    data () {
        return {
            login: null,
            couponType: null,
            couponList: [],
            edit: null,
            subtitle: '쿠폰 보기',
            contents: [
                { icon: 'mdi-tag', title: '쿠폰명', text: '' },
                { icon: 'mdi-clock-outline', title: '시간', text: ''},
                { icon: 'mdi-pencil', title: '메모', text: '' },
                { icon: 'mdi-calendar-plus', title: '등록일', text: '' },
                { icon: 'mdi-calendar-refresh', title: '수정일', text: '' },
            ],
        }
    },
    methods: {
        select: function (couponType) {
            if (this.edit) {
                this.edit = null
            }
            if (couponType.id > 0) {
                this.couponType = couponType
                this.setContent()
            }
        },

        setContent: function () {
            this.subtitle = '쿠폰 보기'
            this.contents[0].text = this.couponType.name
            this.contents[1].text = this.couponType.time
            this.contents[2].text = this.couponType.memo
            this.contents[3].text = this.couponType.cdate.slice(0, 19).replace('T', ' ')
            this.contents[4].text = this.couponType.mdate ? this.couponType.mdate.slice(0, 19).replace('T', ' ') : ''
        },

        add: function () {
            this.subtitle = '쿠폰 등록'
            this.couponType = null
            this.edit = {
                type: 0,
                name: '',
                time: 0,
                memo: ''
            }
            setTimeout(() => { document.getElementById('name').focus() }, 1000)
        },

        insert: function () {
            if (this.edit.name.trim() == '') {
                alert('쿠폰명을 입력하세요.')
                return
            }
            let params = new URLSearchParams()
            params.append('name', this.edit.name)
            params.append('time', this.edit.time)
            params.append('memo', this.edit.memo ? this.edit.memo : '')
            axios.post('/api/coupon/type/insert', params, util.headers)
            .then(response => {
                if (response.data.error) {
                    this.couponList.shift()
                    console.log(response.data.error)
                }
                else {
                    this.couponType = response.data.couponType
                    this.couponList.push(this.couponType)
                    this.setContent()
                }
            })
        },

        remove: function () {
            if (!confirm(this.couponType.name + ' 쿠폰을 정말로 삭제하시겠습니까?')) {
                return
            }
            let params = new URLSearchParams()
            params.append('id', this.couponType.id)
            axios.post('/api/coupon/type/delete', params, util.headers)
            .then(response => {
                if (response.data.error) {
                    console.log(response.data.error)
                }
                else {
                    let index = this.couponList.map(couponType => { return couponType.id }).indexOf(this.couponType.id)
                    if (index >= 0) {
                        this.couponList.splice(index, 1)
                        this.couponType = null
                    }
                }
            })
        },

        cancel: function () {
            if (this.edit) {
                this.edit = null
            }
        },

        modify: function () {
            this.subtitle = '쿠폰 수정'
            this.edit = JSON.parse(JSON.stringify(this.couponType))
        },

        update: function () {
            if (this.edit.name.trim() == '') {
                alert('쿠폰명을 입력하세요.')
                return
            }
            let params = new URLSearchParams()
            params.append('id', this.edit.id)
            params.append('name', this.edit.name)
            params.append('time', this.edit.time)
            params.append('memo', this.edit.memo ? this.edit.memo : '')
            axios.post('/api/coupon/type/update', params, util.headers)
            .then(response => {
                if (response.data.error) {
                    console.log(response.data.error)
                }
                else {
                    this.edit = null
                    let couponType = response.data.couponType
                    this.couponType.type = couponType.type
                    this.couponType.name = couponType.name
                    this.couponType.time = couponType.time
                    this.couponType.memo = couponType.memo
                    this.couponType.cdate = couponType.cdate
                    this.couponType.mdate = couponType.mdate
                    this.setContent()
                }
            })
        }
    },
    created () {
        console.clear()
        let json = localStorage.getItem('login')
        if (json) {
            this.login = JSON.parse(json)
        }
        if (this.login) {
            this.$emit('login', this.login)

            axios.get('/api/coupon/type/list')
            .then(response => {
                if (response.data.error)
                    console.log(response.data.error)
                else {
                    this.couponList = response.data.list
                }
            })
        }
        else {
            this.$router.push('/login')
        }
    }
}
</script>
<style scoped>

</style>